import request from "./request";
import { apiRequest } from "./apirequest";



export const getCountryList = () => apiRequest({ endpoint: "/admin/settings/countries" });
export const getStateList = (countryID) => apiRequest({ endpoint: `/admin/settings/states/${countryID}` });
export const getCityList = (stateID) => {
    console.log("State ID:", stateID); // Console log the stateID
    return apiRequest({ endpoint: `/admin/settings/cities/${stateID}` });
};

export const getCorporateList  = () => apiRequest({ endpoint: "/web/corporate" });
export const getProductList  = () => apiRequest({ endpoint: "/web/product?isCombo=false&status=Active" });
export const fetchOtpVerificationApi = (data) => apiRequest({ endpoint: "/web/user/otp-verify",method: "PUT", data: data });
export const getUserInfo = () => apiRequest({ endpoint: "/web/user/user-info" });
export const getOrderDetails =  (orderId) => apiRequest({endpoint: `/web/order/details/${orderId}`});
export const getOrderTrackingDetails =  (orderId) => apiRequest({endpoint: `/web/order/tracking-shipment/${orderId}`});
export const  getHelpList = () => apiRequest({endpoint: "web/setting/help"});
 export const ProfileUpdateOtpRequest = (mobile) => apiRequest({endpoint: "/web/user/auth/send-mobile-otp", method : "POST", data:{"mobile": mobile} });
export const  profileOtpConfirm =  (data) => apiRequest({endpoint : "/web/user/mobile-otp-verify", method: "PUT", data:data})

